module.exports = __webpack_public_path__ + "static/movantik-logo-ee24ea2985f225fa15458a496bce50d5.png";